import * as actionTypes from 'constants/ActionTypes';

export function sendTrain(data) {
    return {
        type: actionTypes.SEND_TRAIN.REQUEST,
        data,
    };
}



// WEBPACK FOOTER //
// ./app/actions/train.js